import { useState, useEffect } from "react";
import type { HelpArticle, NavNode } from "../lib/types";
import { Sidebar } from "./Sidebar";
import { SearchBar } from "./SearchBar";
import { MobileDrawer } from "./MobileDrawer";

interface LayoutProps {
  navTree: NavNode[];
  articles: HelpArticle[];
  children: React.ReactNode;
}

export function Layout({ navTree, articles, children }: LayoutProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    function onScroll() {
      setScrolled(window.scrollY > 4);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="app-layout">
      <header className={`app-header ${scrolled ? "scrolled" : ""}`}>
        <div className="header-content">
          <div className="header-left">
            <MobileDrawer navTree={navTree} />
            <a href="/" className="header-logo">
              <span className="logo-text">TrustReq</span>
              <span className="logo-subtitle">Help Centre</span>
            </a>
          </div>
          <div className="header-search">
            <SearchBar articles={articles} />
          </div>
        </div>
      </header>
      <div className="app-body">
        <aside className="sidebar">
          <Sidebar navTree={navTree} />
        </aside>
        <main className="main-content">{children}</main>
      </div>
      <footer className="app-footer">
        <div className="footer-content">
          <span>© {new Date().getFullYear()} TrustReq. All rights reserved.</span>
          <a href="/terms-of-use" className="footer-link">Terms</a>
          <a href="/privacy-policy" className="footer-link">Privacy</a>
        </div>
      </footer>
    </div>
  );
}
